import * as React from "react";
import TextLogo from "../static/images/kanopi-logo-text.svg";
import { Block } from "baseui/block";
import { KIND } from "./constants";
import { useStyletron } from "kanopi-components/theme/useStyletron";
import { useGlobal } from "kanopi-components/useGlobal";

export function Logo({
  kind,
  src = TextLogo,
  altText = "",
  ...restProps
}: {
  kind?: KIND;
  src?: string;
  altText?: string;
}) {
  const [, theme] = useStyletron();

  // FIXME: Quick workaround to enlarge the logo size for Fast Hippo
  let logoHeight = [
    theme.sizing.scale800,
    theme.sizing.scale800,
    theme.sizing.scale900,
  ];
  if (altText === "Fast Hippo") {
    logoHeight = [
      theme.sizing.scale1600,
      theme.sizing.scale1600,
      theme.sizing.scale2400,
    ];
  }

  return (
    <Block height={logoHeight} {...restProps}>
      <img
        src={src}
        alt={altText ? `${altText} logo` : "logo"}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    </Block>
  );
}

Logo.KIND = KIND;
